__turbopack_context__.v({
  "claimHidden": "HeaderCompact-module__bGPE1G__claimHidden",
  "header": "HeaderCompact-module__bGPE1G__header",
  "headerClaim": "HeaderCompact-module__bGPE1G__headerClaim",
  "headerLogo": "HeaderCompact-module__bGPE1G__headerLogo",
  "headerLogoLink": "HeaderCompact-module__bGPE1G__headerLogoLink",
  "imageContainer": "HeaderCompact-module__bGPE1G__imageContainer",
  "inner": "HeaderCompact-module__bGPE1G__inner",
  "logoDesktop": "HeaderCompact-module__bGPE1G__logoDesktop",
});
